import { ChevronDown } from "lucide-react";
import { useState, useRef, useEffect } from "react";
import { useStore } from "@/lib/store";

export function AccountSwitcher() {
  const { user, activeAccountId, setActiveAccountId, activeAccount } = useStore();
  const [open, setOpen] = useState(false);
  const ref = useRef<HTMLDivElement>(null);

  const current = activeAccount();

  useEffect(() => {
    function handleClick(e: MouseEvent) {
      if (ref.current && !ref.current.contains(e.target as Node)) {
        setOpen(false);
      }
    }
    document.addEventListener("mousedown", handleClick);
    return () => document.removeEventListener("mousedown", handleClick);
  }, []);

  if (!user || user.accounts.length <= 1) {
    return current ? (
      <div className="flex items-center gap-2 px-3 py-2">
        <div className="h-6 w-6 rounded-full bg-neutral-200 flex items-center justify-center text-xs font-semibold">
          {current.username.charAt(0).toUpperCase()}
        </div>
        <span className="text-sm font-medium truncate">@{current.username}</span>
      </div>
    ) : null;
  }

  return (
    <div ref={ref} className="relative">
      <button
        onClick={() => setOpen(!open)}
        className="flex w-full items-center gap-2 rounded-lg px-3 py-2 hover:bg-surface-hover transition-colors"
      >
        <div className="h-6 w-6 rounded-full bg-neutral-200 flex items-center justify-center text-xs font-semibold">
          {current?.username.charAt(0).toUpperCase() || "?"}
        </div>
        <span className="flex-1 text-left text-sm font-medium truncate">
          @{current?.username || "Select"}
        </span>
        <ChevronDown className="h-4 w-4 text-neutral-400" />
      </button>

      {open && (
        <div className="absolute left-0 right-0 top-full z-40 mt-1 rounded-lg border border-border bg-white py-1 shadow-lg">
          {user.accounts.map((account) => (
            <button
              key={account.id}
              onClick={() => {
                setActiveAccountId(account.id);
                setOpen(false);
              }}
              className={`flex w-full items-center gap-2 px-3 py-2 text-left text-sm hover:bg-surface-hover transition-colors ${
                account.id === activeAccountId ? "font-semibold" : ""
              }`}
            >
              <div className="h-5 w-5 rounded-full bg-neutral-200 flex items-center justify-center text-[10px] font-semibold">
                {account.username.charAt(0).toUpperCase()}
              </div>
              <span className="truncate">@{account.username}</span>
              {account.isPrimary && (
                <span className="ml-auto text-[10px] text-neutral-400 uppercase tracking-wide">Primary</span>
              )}
            </button>
          ))}
        </div>
      )}
    </div>
  );
}
